import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSelect } from './Select.definition';
import { chameleonOption } from './Option.definition';
import { chameleonSvg } from '../Svg';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonSvg({ prefix }), chameleonSelect({ prefix }), chameleonOption({ prefix }));
}
